export class ShareResourcePermissionError extends Error {
}